import { Injectable, signal } from '@angular/core';
import { makeBlankTenantView, TenantView } from './models';


/*
Tenant_id INT(10), Email VARCHAR(50), First_name VARCHAR(255), Last_name VARCHAR(255), Phone VARCHAR(255), Password VARCHAR(255), Unit_id INT(11), Building_name VARCHAR(100), Address VARCHAR(300), Unit_number VARCHAR(100), Region VARCHAR(255), City VARCHAR(255), Street_address VARCHAR(255), Google_map TEXT
*/

export type JSONResponse = {
	success: boolean;
	data: any;
	error: string;
}



export type authPayload = {
	email: string;
	password: string;
}


@Injectable({
	providedIn: 'root'
})
export class UserService {
	public _isLoggedIn = false;
	public _email: string | null = null;

	// Signal to hold the currently logged-in tenant data
	currentTennant = signal<TenantView>(makeBlankTenantView());

	async setLanguage(lang: number): Promise<JSONResponse> {
		//send language update to server
		let response = await fetch('https://delta.mycapx.com/Tenant_Services_Controller/setLanguage', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			credentials: 'include', // <-- correct usage
			body: JSON.stringify({ language: lang }),
		}).then((res) => {
			console.log(res);
			return res.json()
		}).then((data: JSONResponse) => {
			console.log('Response Data:', data);
			if (data.success && data.data) {
				//update current tenant signal
				let updatedTennant = this.currentTennant();
				updatedTennant.Language = lang;
				this.currentTennant.set(updatedTennant);
			}
			return data;
		}
		).catch((error) => {
			console.log('Error:', error);
			return{ success: false, data: null, error: 'Network error' };
		});
		return response;
	}

	async checkLoggedIn(): Promise<JSONResponse> {
		//first we need to send the ci_user_session	cooke to the server to validate the session

		let response = await fetch('https://delta.mycapx.com/Tenant_Services_Controller/checkSession', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			},
			credentials: 'include', // <-- correct usage
		}).then((res) => {
			console.log(res);
			return res.json()
		}).then((data: JSONResponse) => {
			console.log('Response Data:', data);
			if (data.success && data.data) {
				this._isLoggedIn = true;
				console.log('Setting currentTennant signal with data:', data.data);
				this.currentTennant.set(data.data as TenantView);
			} else {
				this._isLoggedIn = false;
				this.currentTennant.set(makeBlankTenantView());
			}
			return data;

		}).catch((error) => {
			console.log('Error:', error);
			return { success: false, data: null, error: 'Network error' };
		});

		this._isLoggedIn = false; //update based on actual session check
		return response;
	}

	async login(username: string, password: string): Promise<JSONResponse> {
		const payload: authPayload = { email: username, password: password };
		let response = await fetch('https://delta.mycapx.com/Tenant_Services_Controller/authenticateTenant', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			credentials: 'include', // <-- correct usage
			body: JSON.stringify(payload),
		}).then((res) => {
			console.log(res);
			return res.json()
		}).then((data: JSONResponse) => {
			console.log('Response Data:', data);
			if (data.success && data.data) {
				this._isLoggedIn = true;
				this._email = username;
				this.currentTennant.set(data.data as TenantView);
			} else {
				this._isLoggedIn = false;
				this._email = null;
				this.currentTennant.set(makeBlankTenantView());
			}
			return data;
		}
		).catch((error) => {
			console.log('Error:', error);
			return { success: false, data: null, error: 'Network error' };
		});
		return response;
	}

	logout(): void {
		this._isLoggedIn = false;
		this._email = null;
		this.currentTennant.set(makeBlankTenantView());
	}

	get isLoggedIn(): boolean {
		return this._isLoggedIn;
	}

	get username(): string | null {
		return this._email;
	}

	async logoutFromServer(): Promise<JSONResponse> {
		let response = await fetch('https://delta.mycapx.com/Tenant_Services_Controller/logoutTenant', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			},
			credentials: 'include', // <-- correct usage
		}).then((res) => {
			console.log(res);
			return res.json()
		}
		).then((data: JSONResponse) => {
			console.log('Response Data:', data);
			if (data.success) {
				this.logout();
			}
			return data;
		}
		).catch((error) => {
			console.log('Error:', error);
			return { success: false, data: null, error: 'Network error' };
		});
		return response;
	}
}